import type { EventTuple } from '@/events/types'
import type { PageEventHandler } from '@/play/pageTypes'
import { applyLiquidChanges, liquidVoxel, mergeLiquidChanges } from '@/play/liquid/changes'
import type { LiquidChanges } from '@/play/liquid/liquidSim'

export const SPILL_SETTLE = 'experience.spill.settle'

/** Commit of a flow (settled, interrupted, or one draft frame's delta). */
export type SpillSettlePayload = LiquidChanges

export const tintVoxel = liquidVoxel
export const applySpillSettle = applyLiquidChanges

/** Coalesces two settle events (b after a) into one; null when either is not a settle event. */
export function combineSpillSettleEvents(a: EventTuple, b: EventTuple): EventTuple | null {
  if (a[0] !== SPILL_SETTLE || b[0] !== SPILL_SETTLE) return null
  return [SPILL_SETTLE, mergeLiquidChanges(a[1] as SpillSettlePayload, b[1] as SpillSettlePayload)] as unknown as EventTuple
}

/** Reducer handlers for Spill (`experience.spill.*`). */
export const eventHandlers: Record<string, PageEventHandler> = {
  [SPILL_SETTLE]: (ctx, event) => {
    applySpillSettle(ctx.base, event[1] as SpillSettlePayload, ctx.meta?.bounds)
  },
}

/** The same handlers under the page's earlier name (tests). */
export const spillEventHandlers = eventHandlers
